import { render } from "./AccessoryRow.vue?vue&type=template&id=c7262614"
import script from "./AccessoryRow.vue?vue&type=script&lang=js"
export * from "./AccessoryRow.vue?vue&type=script&lang=js"

import exportComponent from "/Users/elisabetta/Code/salvi-rental/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__